// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyATJ5SpV_So2R8d6GVgp1QgSIiyz51XS64",
  authDomain: "burn-planner.web.app",
  projectId: "burning-man-compass",
  storageBucket: "burning-man-compass.appspot.com",
  messagingSenderId: "551681490588",
  appId: "1:551681490588:web:d011ca7850454989d57759",
  measurementId: "G-YRVJXCT50P"
};

const VAPID_KEY = 'BF0JgKB29SnwdCh10fS-2VdVg3cRJjB3InLX4rQOzYMauZQL_MeGO74U6uEc5zruntj3jqAsy-xoRy8CClWoNHI';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db, VAPID_KEY };